import type { CityConfig } from "../city-template/types";

export const rockyMountConfig: CityConfig = {
  city: "Rocky Mount",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "rocky-mount",
  route: "/rocky-mount",
  title: "Emergency Passport Rocky Mount, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Rocky Mount, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Nash & Edgecombe County and the I-95 corridor. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Rocky Mount, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Rocky Mount and Nash County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Rocky%20Mount%20North%20Carolina%20cityscape%20at%20golden%20hour%20with%20charming%20downtown%20historic%20district%2C%20renovated%20brick%20buildings%20along%20the%20Tar%20River%2C%20modern%20civic%20center%20and%20train%20station%20visible%2C%20lush%20green%20trees%20of%20the%20eastern%20North%20Carolina%20flatlands%2C%20warm%20sunset%20light%20over%20Nash%20County%2C%20clean%20sky%20with%20soft%20clouds%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20small-town%20southern%20charm%20along%20the%20interstate%20corridor%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=rocky-mount-hero-nc-001&orientation=landscape",
  heroImageAlt: "Rocky Mount North Carolina downtown historic district along the Tar River at golden hour in Nash County",
  geoPosition: "35.9382;-77.7905",
  geoPlacename: "Rocky Mount, North Carolina",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 260 miles north of Rocky Mount — about 4 hours via I-95",
  },
  nearbyCitiesZips: [
    { name: "Rocky Mount", zips: "27801, 27802, 27803, 27804" },
    { name: "Nashville", zips: "27856" },
    { name: "Wilson", zips: "27893, 27894, 27895, 27896" },
    { name: "Tarboro", zips: "27886" },
    { name: "Greenville", zips: "27834, 27835, 27836, 27858" },
    { name: "Roanoke Rapids", zips: "27870" },
    { name: "Henderson", zips: "27536, 27537" },
    { name: "Louisburg", zips: "27549" },
    { name: "Wake Forest", zips: "27587, 27588" },
    { name: "Knightdale", zips: "27545" },
    { name: "Zebulon", zips: "27597" },
    { name: "Raleigh", zips: "27601–27699" },
    { name: "Durham", zips: "27701–27717" },
    { name: "Goldsboro", zips: "27530, 27531, 27532, 27533, 27534" },
    { name: "Williamston", zips: "27892" },
    { name: "Kinston", zips: "28501, 28502, 28503, 28504" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Nash County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "I-95 Corridor Hub", desc: "Serving Rocky Mount, Nashville, and all of Nash & Edgecombe County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Raleigh, NC", route: "/raleigh" },
    { name: "Fast passport renewal in Durham, NC", route: "/durham" },
    { name: "Emergency passport help in Greenville, NC", route: "/greenville" },
    { name: "Urgent passport services in Goldsboro, NC", route: "/goldsboro" },
    { name: "Passport courier services in Wilson, NC", route: "/wilson" },
    { name: "Same-day passport help in Wake Forest, NC", route: "/wake-forest" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Rocky Mount remotely via secure courier. We do not have a walk-in office in Rocky Mount — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Nash County and Edgecombe County travelers.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Nash County, Edgecombe County, and the I-95 corridor",
  serviceAreaIntro: "From downtown Rocky Mount's historic district along the Tar River to the Nashville suburbs, from the Wilson corridor to the rural communities of Tarboro, Roanoke Rapids, and Henderson — Fast Passport Center serves the entire Rocky Mount region. We regularly help travelers from Greenville, Louisburg, Wake Forest, Knightdale, Raleigh, Durham, and Goldsboro get their passports fast.",
  nearbyCitiesIntro: "We serve all Rocky Mount neighborhoods and the surrounding Nash & Edgecombe County area including Nashville, Wilson, Tarboro, Greenville, Roanoke Rapids, Henderson, Louisburg, Wake Forest, Knightdale, Zebulon, Raleigh, Durham, Goldsboro, Williamston, and Kinston. If you are anywhere in the I-95 corridor or eastern North Carolina, we have you covered.",
  howItWorksIntro: "Most Rocky Mount travelers complete everything online and ship documents overnight. No need to drive to Washington DC or wait in line at the regional agency.",
  mistakesIntro: "Rocky Mount travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Rocky Mount and Nash County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Rocky Mount? Here are the most common ones we hear from Nash County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Rocky Mount international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Tasha B.",
      location: "Rocky Mount, NC",
      rating: 5,
      text: "My passport expired 2 days before a cruise to the Bahamas. Fast Passport Center had my renewal ready in 27 hours. I didn't have to drive to Atlanta or miss my vacation. Incredible service for Nash County.",
      service: "Passport Renewal",
    },
    {
      name: "Robert M.",
      location: "Nashville, NC",
      rating: 5,
      text: "Emergency passport for a family emergency in London. Got it in 33 hours. The team kept me updated every step. Best passport service for anyone along the I-95 corridor.",
      service: "Emergency Passport",
    },
    {
      name: "Keisha W.",
      location: "Wilson, NC",
      rating: 5,
      text: "First passports for my 9 and 11-year-olds before a Disney cruise. Fast Passport Center walked us through every document. Had both passports in 5 days. Completely stress-free for a Wilson family.",
      service: "Child Passport",
    },
    {
      name: "James L.",
      location: "Tarboro, NC",
      rating: 5,
      text: "Lost my passport 4 days before a business trip to Toronto. Fast Passport Center had a replacement in 30 hours. Lifesavers for Edgecombe County travelers.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "rocky-mount-1",
      name: "Rocky Mount Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "219 N Church St",
      city: "Rocky Mount",
      state: "NC",
      zip: "27801",
      phone: "(252) 446-6141",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Rocky Mount",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Rocky Mount facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "rocky-mount-2",
      name: "Nashville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "107 S Barnes St",
      city: "Nashville",
      state: "NC",
      zip: "27856",
      phone: "(252) 459-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles west of Rocky Mount",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Nashville and western Nash County residents. Less crowded than Rocky Mount. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "rocky-mount-3",
      name: "Wilson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "202 Ward Blvd",
      city: "Wilson",
      state: "NC",
      zip: "27893",
      phone: "(252) 237-0131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles south of Rocky Mount",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Wilson County and southern Nash County. Alternative for Rocky Mount south side residents.",
      icon: "ri-mail-line",
    },
    {
      id: "rocky-mount-4",
      name: "Tarboro Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "624 W Wilson St",
      city: "Tarboro",
      state: "NC",
      zip: "27886",
      phone: "(252) 823-2101",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles east of Rocky Mount",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Edgecombe County and eastern Nash County. Alternative for Rocky Mount east side residents.",
      icon: "ri-mail-line",
    },
    {
      id: "rocky-mount-5",
      name: "Nash County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "120 W Washington St",
      city: "Nashville",
      state: "NC",
      zip: "27856",
      phone: "(252) 459-4000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Nashville, Courthouse",
      website: "https://www.nashcountync.gov/",
      websiteLabel: "Nash County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "rocky-mount-6",
      name: "Raleigh Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3800 S Halifax Rd",
      city: "Raleigh",
      state: "NC",
      zip: "27604",
      phone: "(919) 850-9101",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "55 miles west of Rocky Mount",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Wake County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4 hour drive to Washington DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Rocky Mount photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Nash County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Rocky Mount applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Nash County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Rocky Mount travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Rocky Mount." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Rocky Mount address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Rocky Mount before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Rocky Mount for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4 hour drive to Washington DC." },
    { q: "How fast can I renew my passport in Rocky Mount?", a: "Fast Passport Center offers fast passport renewal in Rocky Mount in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Rocky Mount?", a: "The nearest regional passport agency to Rocky Mount is the Washington DC Passport Agency at 600 19th St NW, Washington DC 20006, approximately 260 miles north via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Rocky Mount without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Rocky Mount?", a: "Same-day passport appointments are only available at the Washington DC Passport Agency — approximately 4 hours from Rocky Mount — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Nash County residents." },
    { q: "Do you serve the entire I-95 corridor in North Carolina?", a: "Absolutely. Fast Passport Center serves the entire I-95 corridor in North Carolina including Rocky Mount, Nashville, Wilson, Roanoke Rapids, Henderson, Louisburg, and all surrounding communities. Our courier service works seamlessly from any address in Nash County, Edgecombe County, and the eastern North Carolina corridor." },
    { q: "Can I expedite a child passport in Rocky Mount?", a: "Yes. Fast Passport Center expedites child passports in Rocky Mount for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Nash County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Rocky Mount with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Washington DC Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Rocky Mount", address: "800 N Wesleyan Blvd, Rocky Mount, NC 27804", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Rocky Mount", address: "1340 N Wesleyan Blvd, Rocky Mount, NC 27804", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Rocky Mount", address: "1510 Parham Dr, Rocky Mount, NC 27804", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Wilson", address: "1800 Raleigh Rd Pkwy W, Wilson, NC 27896", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Wilson", address: "301 Raleigh Rd Pkwy W, Wilson, NC 27896", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Wilson", address: "2915 Raleigh Rd Pkwy W, Wilson, NC 27896", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Greenville", address: "2100 E 10th St, Greenville, NC 27858", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Tarboro", address: "600 N Main St, Tarboro, NC 27886", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Rocky Mount",
      address: "1331 S Wesleyan Blvd, Rocky Mount, NC 27803",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Wilson",
      address: "2915 Raleigh Rd Pkwy W, Wilson, NC 27896",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Raleigh",
      address: "8301 Old Stage Rd, Raleigh, NC 27603",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Wake County. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Greenville",
      address: "207 E Arlington Blvd, Greenville, NC 27834",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Pitt County. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "60 miles west of Rocky Mount",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international hub with direct flights to Europe, Canada, Mexico, and the Caribbean. The closest major airport for Rocky Mount travelers.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: true,
    },
    {
      code: "RWI",
      name: "Rocky Mount-Wilson Airport",
      distance: "8 miles south of Rocky Mount",
      address: "300 Airport Rd, Rocky Mount, NC 27804",
      note: "General aviation airport serving private and charter flights. Limited commercial service.",
      flightUrl: "https://www.rockymountwilsonairport.com/",
      flightLabel: "RWI Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "160 miles west of Rocky Mount",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "American Airlines hub with the most international flight options from North Carolina. Consider for long-haul international travel.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { name: "NCDHHS Vital Records", url: "https://vitalrecords.nc.gov/", description: "North Carolina birth, death, marriage, and divorce certificates" },
    { name: "Nash County Register of Deeds", url: "https://www.nashcountync.gov/160/Register-of-Deeds", description: "Birth, death, and marriage records for Nash County" },
    { name: "Nash County Superior Court", url: "https://www.nccourts.gov/locations/nash-county", description: "Divorce records and court documents for Nash County" },
  ],
};